import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import {
  MatDialogRef,
  MatDialogModule,
  MatDialog,
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

import { InformationBoxComponent } from '@shared/information-box/information-box.component';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'app-error-recovery-dialog',
  templateUrl: './error-recovery-dialog.component.html',
  styleUrls: ['./error-recovery-dialog.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatDialogModule,
    MatButtonModule,
    MatIconModule,
    InformationBoxComponent,
  ],
})
export class ErrorRecoveryDialogComponent {
  static async open(dialog: MatDialog) {
    // After Sentry dialog closes, show Material Design recovery dialog
    const dialogRef = dialog.open(ErrorRecoveryDialogComponent, {
      width: '600px',
      disableClose: true, // Prevent closing by clicking outside
    });

    const shouldRefresh = await firstValueFrom(dialogRef.afterClosed());

    if (shouldRefresh === true) {
      // User chose to refresh
      localStorage.setItem('app_recovered_from_crash', 'true');
      window.location.reload();
    } else if (shouldRefresh === false) {
      // User chose not to refresh - only need immediate warning, no persistence needed
      // The localStorage flag is only for showing warnings after navigation/refresh
      // For immediate same-session warning, just dispatch the event
      window.dispatchEvent(
        new CustomEvent('app-unstable-state', {
          detail: { showWarning: true },
        })
      );
    }
    // If shouldRefresh is undefined, user closed dialog without choice - treat as "continue"
    else {
      window.dispatchEvent(
        new CustomEvent('app-unstable-state', {
          detail: { showWarning: true },
        })
      );
    }
  }
  dialogRef = inject(MatDialogRef<ErrorRecoveryDialogComponent>);

  onRefreshClick(): void {
    this.dialogRef.close(true);
  }

  onContinueClick(): void {
    this.dialogRef.close(false);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
